export default __webpack_public_path__ + "static/media/inbound-at-sea.d0779437.svg";